import { Editor } from '@tiptap/react';
import { createContext, useContext } from 'react';

export interface IRichTextEditorContext {
  editor: Editor;
  id: string;
}

export const useRichTextEditorContext = () =>
  useContext<IRichTextEditorContext>(RichTextEditorContext);

export const RichTextEditorContext =
  createContext<IRichTextEditorContext>(null);
